export function crmGroupSelectAndLabel() {
  return {
    restrict: 'E',
    template: require('./crm-group-select-and-label.directive.html'),
    scope: {
      entry: '='
    },
    controller: controller
  };
}

controller.$inject = ['$scope'];
function controller($scope) {
  $scope.onSearchGroupUpdated = onSearchGroupUpdated;

  function onSearchGroupUpdated() {
    if ($scope.entry.search_group === 'NAME') {
      $scope.entry.display_label = 'Name';
    } else if ($scope.entry.search_group === 'EMAIL') {
      $scope.entry.display_label = 'Email';
    } else if ($scope.entry.search_group === 'PHONE') {
      $scope.entry.display_label = 'Phone';
    } else {
      $scope.entry.display_label = '';
    }
  }
}
